import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  AppPageComponent,
  AppSidenavComponent,
  AppBarComponent,
  AppBarTitleComponent,
  AppBarExpandedTabsComponent,
  AppBarActionsComponent
} from 'common';
import { appPageComponentDataMaster, appPageComponentDataDetail } from '../../app.data';
import { UserMenuComponent } from '../user-menu/user-menu.component';
import { UserRoleListComponent } from './user-role-list/user-role-list.component';
import { AppPageResolver, AppSidenavResolver } from '../../app.resolver';
import { UserRoleQueryResolver, UserRoleResolver } from './user-role.resolver';
import { UserRoleDetailsComponent } from './user-role-details/user-role-details.component';
import { ClientAllResolver } from '../../auth/client/client.resolver';
import { UserPermissionGroupQueryResolver } from '../user-permission-group/user-permission-group.resolver';
import { AdminAppBarExpandedTabsResolver } from '../../admin/admin.resolver';
import { UserRoleAssigneesResolver } from './user-role-assignees-list/user-role-assignees-resolver';
import { BOAuthGuard } from '../../guards/oauth.guard';

const appPageDataMaster = appPageComponentDataMaster({
  appBarTitle: 'Admin',
  sideNavItem: 'admin'
});
const appPageDataDetail = appPageComponentDataDetail();

const routes: Routes = [
  {
    path: '',
    canActivate: [BOAuthGuard],
    children: [
      {
        path: 'admin/role',
        component: AppPageComponent,
        data: appPageDataMaster,
        resolve: {
          appBarExpandedTabs: AdminAppBarExpandedTabsResolver,
          appPage: AppPageResolver,
          appSidenav: AppSidenavResolver
        },
        children: [
          {
            path: '',
            outlet: 'sidenav-content',
            component: AppSidenavComponent
          },
          {
            path: '',
            component: AppBarComponent,
            outlet: 'app-bar',
            children: [
              {
                path: '',
                outlet: 'title',
                component: AppBarTitleComponent,
              },
              {
                path: '',
                outlet: 'right',
                component: UserMenuComponent,
              },
              {
                path: '',
                outlet: 'expanded',
                component: AppBarExpandedTabsComponent
              }
            ]
          },
          {
            path: '',
            component: UserRoleListComponent,
            runGuardsAndResolvers: "paramsOrQueryParamsChange",
            resolve: {
              clients: ClientAllResolver,
              roleQueryResult: UserRoleQueryResolver
            }
          }
        ]
      },
      {
        path: 'admin/role/:id',
        component: AppPageComponent,
        data: {
          appBar: appPageDataDetail.appBar,
          appBarActions: appPageDataDetail.appBarActions,
          appPage: {
            contentClass: 'fill',
            contentAlignment: 'start-start',
            contentWithoutPadding: true
          }
        },
        resolve: { userRoleAssignees: UserRoleAssigneesResolver },
        children: [
          {
            path: '',
            component: AppBarComponent,
            outlet: 'app-bar',
            children: [
              {
                path: '',
                outlet: 'title',
                component: AppBarTitleComponent,
              },
              {
                path: '',
                outlet: 'right',
                component: AppBarActionsComponent,
              }
            ]
          },
          {
            path: '',
            component: UserRoleDetailsComponent,
            resolve: {
              role: UserRoleResolver,
              permissionGroups: UserPermissionGroupQueryResolver
            }
          }
        ]
      }]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoleRoutingModule { }
